export type UpdateFlush = () => Promise<boolean>;
export type RegisterUpdateFlush = (flush: UpdateFlush) => () => void;

const noPendingSave: UpdateFlush = async () => true;

/** Coordinates a waiting service worker with the currently mounted autosave controller. */
export class UpdateCoordinator {
  private flush: UpdateFlush = noPendingSave;

  /** Registers the active editor flush and returns an identity-safe cleanup. */
  public register = (flush: UpdateFlush): (() => void) => {
    this.flush = flush;
    return () => {
      if (this.flush === flush) {
        this.flush = noPendingSave;
      }
    };
  };

  /** Applies an update only after the active editor confirms a successful flush. */
  public async apply(update: () => void | Promise<void>): Promise<boolean> {
    if (!(await this.flush())) {
      return false;
    }
    await update();
    return true;
  }
}
